// extracted by mini-css-extract-plugin
export default {"icon":"IconWarning_icon__v+Dso"};